import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getVideoSettingsByResolution } from 'features/media-streams/constants';

export const useMercuryVideoResolution = () => {
  const { mercuryVideoResolution } = useFlags();

  return useMemo(
    () => getVideoSettingsByResolution(mercuryVideoResolution),
    [mercuryVideoResolution]
  );
};
